import{BaseError as t}from"./BaseError";import"./ValidationError";class o extends t{constructor(a,r={}){r.validationErrors=a,r.translationKey||(r.translationKey="multipleValidationErrors");super(`Multiple ValidationErrors were thrown during validation:
`+a.map(i=>i.message).join(`
---
`),r);this.validationErrors=a}static createFromDetails(a,r){return new this(r.validationErrors,r)}}o._class="MultipleValidationError";export{o as MultipleValidationError};
